import React, { useState } from 'react';
import {
    Modal, ModalBody, ModalHeader, Anchor,  
} from '@americanexpress/dls-react';
import parse from "html-react-parser";

function FootNotes({ content }) {
    const [show, setShow] = useState(false);
    const showModal = () => setShow(true);
    const closeModal = () => setShow(false);
    return (
        <div>
            <Anchor onClick={showModal}>View Footnotes</Anchor>
            {show && (
                <div>
                    <Modal onClose={closeModal}
                    theme={{
                            // allows the modal to be scrollable but scrollbar not to be shown
                            '& > div': {
                                maxWidth: '64.5rem',
                                overflowY: 'auto',
                                msOverflowStyle: 'none',
                                scrollbarWidth: 'none',
                                '::-webkit-scrollbar': { display: 'none' },
                            },
                        }}>
                        <ModalHeader>
                            <h2 className="fluid heading-3">{parse(content.productName)}</h2>
                        </ModalHeader>
                        <ModalBody>
                            <div className="pad-4">
                                <div className="container">
                                    <div className="row">
                                        <ul className="stack" style={{ listStyleType: "none"}}>
                                            {content.footnotes.map(footnote => (
                                                <li key={(footnote.number && footnote.number !== null &&
                                                    footnote.number !== '') ? footnote.number : ""}>
                                                    <div className="row">
                                                        <div className="col-xs-1 text-align-right">
                                                            {parse((footnote.number && footnote.number !== null && footnote.number !== '') ? footnote.number : "")}
                                                        </div>
                                                        <div className="col-xs-11">
                                                            {parse(footnote.description)}
                                                        </div>
                                                    </div>
                                                </li>
                                            ))}                                       
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </ModalBody>
                    </Modal></div>
            )}
        </div>

    );
}

export default FootNotes;